import { createSelector } from '@reduxjs/toolkit'

export const myInterestsSelector = state => state.myInterestsReducer

export const getPendingForDeletion = () =>
  createSelector(myInterestsSelector, state => state.pendingForDeletion)

export const getPendingForInsertion = () =>
  createSelector(myInterestsSelector, state => state.pendingForInsertion)
